import React, { Component } from 'react';
import { Form, Input, Modal, DatePicker, Select } from 'antd';
import moment from 'moment';

const FormItem = Form.Item;
const { Option } = Select;
const dateFormat = 'YYYY/MM/DD';
class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dateString: '',
      currentDate: '',
    };
  }

  componentDidMount() {
    this.setState({
      dateString: moment.unix(Date.now() / 1000).format('YYYY-MM-DD'),
      currentDate: moment.unix(Date.now() / 1000).format('YYYY-MM-DD'),
    });
  }

  handleOk = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.date = this.state.dateString;
        this.props.handleOk(values);
        this.props.form.resetFields();
        this.setState({
          dateString: moment.unix(Date.now() / 1000).format('YYYY-MM-DD'),
        });
      }
    });
  };

  onChange = (date, dateString) => {
    this.setState({
      dateString,
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      visible,
      handleCancel,
    } = this.props;
    const { currentDate } = this.state;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 },
        md: { span: 15 },
      },
    };
    return (
      <Modal
        title="迁出"
        visible={visible}
        onOk={this.handleOk}
        onCancel={() => handleCancel(false)}
      >
        <Form>
          <FormItem label="迁出时间" {...formItemLayout}>
            {getFieldDecorator('date', {
              rules: [{ required: true, message: '请选择迁出时间' }],
              initialValue: moment(currentDate, dateFormat),
            })(<DatePicker onChange={this.onChange} />)}
          </FormItem>
        </Form>
        <Form>
          <FormItem label="迁向场地" {...formItemLayout}>
            {getFieldDecorator('incubatorName', {
              rules: [{ required: true, message: '请填写要迁向的场地' }],
            })(<Input />)}
          </FormItem>
        </Form>
        <Form>
          <FormItem label="迁出理由" {...formItemLayout}>
            {getFieldDecorator('reason', {
              rules: [{ required: true, message: '请填写迁出理由' }],
            })(
              <Select>
                <Option key={1} value="企业无法正常开展">
                  企业无法正常开展
                </Option>
                <Option key={2} value="企业发展良好人员扩招，场地已无法满足需要">
                  企业发展良好人员扩招，场地已无法满足需要
                </Option>
                <Option key={3} value="其他区域的政策吸引">
                  其他区域的政策吸引
                </Option>
                <Option key={4} value="其他">
                  其他
                </Option>
              </Select>,
            )}
          </FormItem>
          <FormItem label="补充说明" {...formItemLayout}>
            {getFieldDecorator('remark')(
              <Input.TextArea
                placeholder="补充说明"
                type="textarea"
                autosize={{ minRows: 3, maxRows: 9 }}
                maxLength={1000}
              />,
            )}
            <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/incubator/workbench/custom/ModalOut.js